import React, { memo, useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import TablePaginationComponent from "./TablePagination";
import TableRowComponent from "./TableRow";
import PropTypes from "prop-types";
import { ThemeProvider, createTheme } from "@mui/material";
import { tableSelectedCellColors } from "../Utils/helper";
import { useSelector } from "react-redux";
const theme = createTheme({
  typography: {
    fontFamily: "Inter",
  },
});

function TableComponent({
  hideColumnWithId = null,
  stickyHeader = true,
  columnHeaderBackgroundColor = "white",
  columnHeaderColor,
  columnHeaderFont = 11,
  columnHeaderFontWeight,
  paddingHeaderStyledTableCell = "15.5px",
  paddingLeftHeaderStyledTableCell = "8px",
  paddingBodyStyledTableCell = "9.25px",
  paddingLeftBodyStyledTableCell,
  columnBodyFont = 10,
  columnBodyColor,
  columnBodyFontWeight,
  alternnateStyledRowColor = "#FBF5FF",
  paddingBody,
  paddingHeader,
  page = 0,
  rowsPerPage = 5,
  count,
  firstButtonClicked = () => {},
  lastButtonClicked = () => {},
  handleNextButtonClick = () => {},
  handleBackButtonClick = () => {},
  onPageDropdownChange = () => {},
  unFlagApiClick = () => {},
  alternnateStyledRow = false,
  vendorDetailsTab = false,
  rowsData = [],
  columnsData = [],
  hideBorders = false,
  tablePagination = true,
  tableBoxShadow,
  tableBorder = "1px solid #E8E8E8",
  TableCollapseContent,
  tablePadding,
  TableCollapseContentDocument,
  onClickFirstPopper = () => {},
  onCloseFirstPopper = () => {},
  onCellClicked = () => {},
  onClickSecondPopper = () => {},
  onCloseSecondPopper = () => {},
  open,
  setOpen,
  noOfPopper,
  secondPopperListItem,
  popperContentMatch = "caseNo",
  isCreateCase = false,
  stickyColumnName = "case_id",
  isApproval = false,
  isDisabled = () => {},
  vendorDetailPadding,
  vendorDetailBorder,
  vendorDetailBorderRadius,
  isCheckbox = true,
  setIsUploadedInvoice = () => {},
  caseId,
  displaySecondTab = false,
  openActionModal = false,
  activeMenu = "",
  firstTabVal,
  isStandardTable = false,
  actionPopperRef = {},
  flagToHideView = false,
  isNoDataRow = false,
  createCaseClickHandler = () => {},
}) {
  const [isActiveStickyColumnBorder, setIsActiveStickyColumnBorder] =
    useState(false);
  const selectedSideBarMenu = useSelector(
    (state) => state?.sidBarSliceMenu?.sideBarMenu
  );
  const StyledTableCell = styled(TableCell)(({ theme }) => {
    let styleObject = {
      [`&.${tableCellClasses.head}`]: {
        backgroundColor: columnHeaderBackgroundColor,
        color: columnHeaderColor,
        fontSize: columnHeaderFont,
        fontWeight: columnHeaderFontWeight,
        paddingLeft: paddingLeftHeaderStyledTableCell,
        paddingRight: paddingHeaderStyledTableCell,
        paddingTop: paddingHeaderStyledTableCell,
        paddingBottom: paddingHeaderStyledTableCell,
      },
      [`&.${tableCellClasses.body}`]: {
        fontSize: columnBodyFont,
        fontWeight: columnBodyFontWeight,
        paddingLeft:
          paddingLeftBodyStyledTableCell || paddingBodyStyledTableCell,
        paddingRight: paddingBodyStyledTableCell,
        paddingTop: paddingBodyStyledTableCell,
        paddingBottom: paddingBodyStyledTableCell,
      },
    };
    if (hideBorders) {
      styleObject = {
        ...styleObject,
        "td, th, tr,": {
          border: 0,
        },
        [`&.${tableCellClasses.head}`]: {
          ...styleObject[`&.${tableCellClasses.head}`],
          border: 0,
          borderBottom: 0,
        },
      };
    }

    return styleObject;
  });

  const StyledTableRow = styled(TableRow)(({ theme }) => {
    if (alternnateStyledRow) {
      return {
        "&:nth-of-type(even)": {
          backgroundColor: alternnateStyledRowColor,
        },
      };
    }
    if (hideBorders) {
      return {
        "td, th, tr, .css-1ot1fjc-MuiTableCell-root ": {
          border: 0,
        },
        [`&.${tableCellClasses.head}`]: {
          border: 0,
          borderBottom: 0,
        },
      };
    }
  });

  const getCellColor = (row, index) => {
    let bgCellColor = index % 2 === 0 ? "white" : "#fbf5ff";
    if (!alternnateStyledRow) {
      bgCellColor = "white";
    }
    if (displaySecondTab || openActionModal) {
      bgCellColor =
        caseId === row?.case_id
          ? tableSelectedCellColors?.[activeMenu]?.[firstTabVal] || bgCellColor
          : bgCellColor;
    }
    return bgCellColor;
  };

  const getBoxShadowStyle = (row) => {
    let boxShadow = "";
    if (displaySecondTab || openActionModal) {
      boxShadow =
        caseId === row?.case_id
          ? {
              position: "relative",
              zIndex: 1,
              boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.15)",
            }
          : {};
    }
    return boxShadow;
  };

  useEffect(() => {
    let element = document?.getElementsByClassName("common-table");
    element[0]?.addEventListener("scroll", (e) => {
      setIsActiveStickyColumnBorder(element[0].scrollLeft > 40);
    });
    return () => {
      let element = document?.getElementsByClassName("common-table");
      element[0]?.removeEventListener("scroll", () => {});
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <TableContainer
        sx={{
          border: tableBorder,
          boxShadow: tableBoxShadow,
          borderRadius: "4px",
          padding: vendorDetailPadding,
        }}
        className="common-table"
      >
        <Table
          stickyHeader={stickyHeader}
          aria-label="sticky table"
          sx={{
            borderRadius: vendorDetailBorderRadius,
            border: vendorDetailBorder,
            padding: tablePadding,
            borderCollapse: "separate",
          }}
        >
          <TableHead>
            <TableRow>
              {columnsData
                ?.filter((column) => column?.id !== hideColumnWithId)
                ?.map((column) => {
                  return (
                    <StyledTableCell
                      key={column.id + Math.random()}
                      align={column.align || "left"}
                      style={{
                        minWidth: column.minWidth,
                        fontSize: column.headerFontSize,
                        maxWidth: column.maxWidth,
                        color: column.colorHeader,
                        // width:column.headerMinWidth,
                        boxSizing: "border-box",
                        padding: 0,
                        margin: 0,
                        paddingLeft: column.headerPaddingLeft,
                        paddingRight: column.headerPaddingRight,
                        paddingTop: column.headerPaddingTop,
                        paddingBottom: column.headerPaddingBottom,
                        position:
                          column?.id === stickyColumnName ? "sticky" : "",
                        left: column?.id === stickyColumnName ? 0 : "",
                        borderRight:
                          column?.id === stickyColumnName &&
                          isActiveStickyColumnBorder
                            ? "2px solid #E8E8E8"
                            : "",
                        width: column?.width,
                      }}
                    >
                      {column?.label}
                    </StyledTableCell>
                  );
                })}
            </TableRow>
          </TableHead>
          {rowsData?.length ? (
            <TableBody>
              {rowsData?.map((row, index) => {
                let bgCellColor = getCellColor(row, index);
                let boxShadow = getBoxShadowStyle(row);
                return (
                  <TableRowComponent
                    key={row?.case_id + Math.random()}
                    StyledTableRow={StyledTableRow}
                    row={row}
                    rowIndex={index}
                    columnsData={columnsData?.filter(
                      (column) => column?.id !== hideColumnWithId
                    )}
                    StyledTableCell={StyledTableCell}
                    vendorDetailsTab={vendorDetailsTab}
                    TableCollapseContent={TableCollapseContent}
                    TableCollapseContentDocument={TableCollapseContentDocument}
                    open={open}
                    setOpen={setOpen}
                    onCloseFirstPopper={onCloseFirstPopper}
                    onClickFirstPopper={onClickFirstPopper}
                    onCellClicked={onCellClicked}
                    onClickSecondPopper={onClickSecondPopper}
                    onCloseSecondPopper={onCloseSecondPopper}
                    noOfPopper={noOfPopper}
                    secondPopperListItem={secondPopperListItem}
                    popperContentMatch={popperContentMatch}
                    isCreateCase={isCreateCase}
                    bgCellColor={bgCellColor}
                    boxShadow={boxShadow}
                    stickyColumnName={stickyColumnName}
                    isActiveStickyColumnBorder={isActiveStickyColumnBorder}
                    isApproval={isApproval}
                    isDisabled={isDisabled}
                    unFlagApiClick={unFlagApiClick}
                    isCheckbox={isCheckbox}
                    setIsUploadedInvoice={setIsUploadedInvoice}
                    firstTabVal={firstTabVal}
                    isStandardTable={isStandardTable}
                    actionPopperRef={actionPopperRef}
                    openActionModal={openActionModal}
                    flagToHideView={flagToHideView}
                    createCaseClickHandler={createCaseClickHandler}
                  />
                );
              })}
            </TableBody>
          ) : isNoDataRow ? (
            <TableBody>
              <StyledTableRow>
                <StyledTableCell
                  align="center"
                  colSpan={columnsData?.length || 1}
                >
                  <span
                    style={{
                      color: "#8f949b",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontstyle: "normal",
                      fontWeight: 600,
                    }}
                  >
                    No Data
                  </span>
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          ) : (
            <TableBody>
              <TableRowComponent
                StyledTableRow={StyledTableRow}
                row={"-"}
                columnsData={columnsData}
                StyledTableCell={StyledTableCell}
                popperContentMatch={popperContentMatch}
                stickyColumnName={stickyColumnName}
                isActiveStickyColumnBorder={isActiveStickyColumnBorder}
                open={10}
                isNoData={true}
                key={"-"}
              />
            </TableBody>
          )}
        </Table>
      </TableContainer>
      {tablePagination ? (
        <TablePaginationComponent
          page={page}
          count={count}
          rowsPerPage={rowsPerPage}
          firstButtonClicked={firstButtonClicked}
          lastButtonClicked={lastButtonClicked}
          handleNextButtonClick={handleNextButtonClick}
          handleBackButtonClick={handleBackButtonClick}
          onPageDropdownChange={onPageDropdownChange}
        />
      ) : null}
    </ThemeProvider>
  );
}

TableComponent.propTypes = {
  stickyHeader: PropTypes.bool,
  columnHeaderBackgroundColor: PropTypes.string,
  selectedColumnBackgroundColor: PropTypes.string,
  columnHeaderColor: PropTypes.string,
  columnHeaderFont: PropTypes.string,
  columnHeaderFontWeight: PropTypes.number,
  columnBodyFont: PropTypes.string,
  columnBodyFontWeight: PropTypes.number,
  paddingHeaderStyledTableCell: PropTypes.string,
  paddingLeftHeaderStyledTableCell: PropTypes.string,
  paddingBodyStyledTableCell: PropTypes.string,
  alternnateStyledRowColor: PropTypes.string,
  paddingBody: PropTypes.string,
  paddingHeader: PropTypes.string,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  count: PropTypes.number,
  firstButtonClicked: PropTypes.func,
  lastButtonClicked: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  handleBackButtonClick: PropTypes.func,
  onPageDropdownChange: PropTypes.func,
  alternnateStyledRow: PropTypes.bool,
  rowsData: PropTypes.array,
  columnsData: PropTypes.array,
  hideBorders: PropTypes.bool,
  tablePagination: PropTypes.bool,
  tableBoxShadow: PropTypes.string,
  tableBorder: PropTypes.string,
  TableCollapseContent: PropTypes.array,
  tablePadding: PropTypes.string,
  TableCollapseContentDocument: PropTypes.bool,
  onCloseFirstPopper: PropTypes.func,
  onClickFirstPopper: PropTypes.func,
  onCellClicked: PropTypes.func,
  onClickSecondPopper: PropTypes.func,
  onCloseSecondPopper: PropTypes.func,
  noOfPopper: PropTypes.number,
  secondPopperListItem: PropTypes.array,
  popperContentMatch: PropTypes.string,
  isCreateCase: PropTypes.bool,
  stickyColumnName: PropTypes.string,
  isApproval: PropTypes.bool,
  isDisabled: PropTypes.func,
  isStandardTable: PropTypes.bool,
  actionPopperRef: PropTypes.object,
};

export default memo(TableComponent);
